import React from 'react';
import DynamicCell from './DynamicCell';

/**
 * List API `venueName` gelirse ekstra getOne yok; yoksa DynamicCell fallback.
 */
const EventVenueCell = ({ row }) => {
  const name = row?.venueName;
  if (name) return <span>{name}</span>;
  if (!row?.venue) return <span>N/A</span>;
  return <DynamicCell reference="venues" id={row.venue} field="name" />;
};

export default EventVenueCell;
